import React, { useContext, useEffect } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import Wait from '@react/react-spectrum/Wait'

export default function Spinner ({
    className,
    caption,
    timeout,
    width,
    height,
    style
}) {
    const { wait, dispatch } = useContext(EasybakeContext)

    useEffect(() => {
        let timerId
        if (wait && timeout) {
            timerId = setTimeout(() => {
                dispatch({ type: 'wait', payload: false })
            }, timeout)
        }

        return () => { // cleanup
            if (timerId) {
                clearTimeout(timerId)
            }
        }
    }, [wait, dispatch, timeout])

    return (
        <React.Fragment>
            {wait &&
                <div className={className} width={width} height={height} style={style}>
                    <Wait centered variant="overBackground" />
                    <div className="caption">
                        {caption}
                    </div>
                </div>
            }
        </React.Fragment>
    )
}
